<template>
  <div class="time-limited-image">
    <img 
      v-if="isImageVisible && !rightAngle" 
      :src="image"
      alt="限时展示图片" 
      class="target-image"
    >
    <img 
      v-if="isImageVisible && rightAngle" 
      :src="image"
      alt="限时展示图片" 
      class="rightAngle"
    >
  </div>
</template>

<script>
export default {
  name: 'TimeLimitedImage',
  props: {
    image: { // 展示文字宽度
      type: String,
      default: () => ''
    },
    rightAngle: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    // 计算属性：判断当前时间是否在目标范围内
    isImageVisible() {
      // 1. 定义目标时间范围（开始时间：2025-09-01 00:00:00，结束时间：2025-09-15 23:59:59）
      const startTime = new Date('2025-09-14 00:00:00').getTime() // 转为时间戳（毫秒）
      const endTime = new Date('2025-10-05 23:59:59').getTime()
      // 2. 获取当前时间的时间戳
      const currentTime = new Date().getTime()
      // 3. 校验：当前时间在开始时间之后、结束时间之前 → 显示图片
      // return currentTime >= startTime && currentTime <= endTime
      const visible = currentTime >= startTime && currentTime <= endTime;
      // 关键：通过自定义事件向父页面传递状态
      this.$emit('update-visible', visible)
      return visible
    }
  },
  // data () {
  //   return {
  //     isImageVisible: false
  //   }
  // },
  // mounted () {
  //   // 1. 定义目标时间范围（开始时间：2025-09-01 00:00:00，结束时间：2025-09-15 23:59:59）
  //     const startTime = new Date('2025-09-02 00:00:00').getTime() // 转为时间戳（毫秒）
  //     const endTime = new Date('2025-10-05 23:59:59').getTime()
  //     // 2. 获取当前时间的时间戳
  //     const currentTime = new Date().getTime()
  //     // 3. 校验：当前时间在开始时间之后、结束时间之前 → 显示图片
  //     // return currentTime >= startTime && currentTime <= endTime
  //     const visible = currentTime >= startTime && currentTime <= endTime;
  //     // 关键：通过自定义事件向父页面传递状态

  //     this.isImageVisible = visible
  //     this.$emit('update-visible', visible)
  // },
}
</script>

<style scoped lang="scss">
.time-limited-image {
  width: 100%;
  text-align: center;
  .target-image {
    max-width: 100%;
    height: auto;
  }
  .rightAngle{
    border-top-left-radius: .16rem;
    border-top-right-radius: .16rem;
  }
}
</style>